import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-lg text-background-50"></i>
            </div>
            <span className="text-lg font-bold text-foreground-950 tracking-tight">韩国漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-200/70 hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-foreground-700 text-base"></i>
            </button>
            <Link
              to="/category/all"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-foreground-950 text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4">
          <div className="flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 py-2 whitespace-nowrap">
              首页
            </Link>
            <Link to="/category/all" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 py-2 whitespace-nowrap">
              分类浏览
            </Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 py-2 whitespace-nowrap">
              关于我们
            </Link>
            <Link
              to="/category/all"
              className="px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-lg text-center whitespace-nowrap"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}